import { useQuery } from '@tanstack/react-query';

import { partnersService } from '@aslanpay/portal-common-lib';

import { PartnerPage } from 'app/components/UI/Table/Table.types';

interface FetchPartnersPageParams {
  query?: string;
  sortBy?: string;
  sort?: 'ASC' | 'DESC';
  page: number;
  size: number;
}

const useFetchPartnersPage = ({ query, sortBy, sort, page, size }: FetchPartnersPageParams) => {
  return useQuery<PartnerPage, Error>(['fetchPartnersPage', query, sortBy, sort, page, size], () =>
    partnersService.fetchPartners({
      status: ['ACTIVE'],
      query,
      sortBy,
      sort,
      page,
      size,
    })
  );
};

export default useFetchPartnersPage;
